export const text = {
  title: 'Online Quote',
  name: 'Name',
  quoteLabel: 'Quote',
  email: 'Email',
  phoneNumber: 'Phone Number',
  address: 'Address',
  quote: 'What would you like a quote on?',
  brand: 'What brand or type are you interested in?',
  nextInformationGather: "Next we will gather same information on your home",
  systemBtu: 'Please select the best answer below to help us size the equipment for the quote',
  sizeDescription: 'What type of home do you have?',
  directional: 'Where is your system located in the home?',
  blowerSpeed: 'Please select the best answer?',
  personalInfo: 'Get Started',
  systemEnhancing: 'Please select any system enhancing optional items you may be interested in below.',
  systemEnhancingTooltipText: 'Optional items are priced separate from equipment at a discount for you to review on your quote. Discounted prices are only good if done at the time of installation',
  permitAndpickup: 'Equip Permit',
  location: 'Various Permit cost varies by your City and/or County. Can you pick the best option below?',
  floodZone: "Is your home in a flood zone?",
  otherNote: 'Any other notes for us to consider for your quote? Or questions you might have for a technician? (Please add them here)',
  financeOptionLabel: 'Financing Options',
  financingOptions: 'Tailored Financial Solutions for You',
  doYouWantToAddMoreQuotes: 'Do you want to add more quotes or not ?',
  financingOptionSubHeadingMessage: 'We get that unexpected costs can be tough on your wallet. That’s why we offer payment plans that fit your budget. At Good Guys Home Services, we want to make getting a new HVAC system or fixing things up easy and affordable. Our financing options mean you can make your home comfy without stressing about the cost. Would you be interested in financing options?',
  financingOptionYesMessage: 'All options are with approved credit by the lender you choose. We can provide an online application link once you decide the best system and option for you.',
  wantToAddMore: 'Want to add more?',
  areYouInterested: 'Are you interested in adding any other type of equipment for the home?',
  quotePreviewLabel: 'Quote Preview',
  serviceCategoryHeading: 'Service Category',
  selectServiceCategoryLabel: 'Please select the service category for your online quote.',
  noServiceCategory: 'No service categories available.',
  pleaseSelectServiceCategory: 'Please select a service category to continue.',
  back: 'Back',
  next: 'Next'
};
